import request from '@/config/axios';

/**
 * 管理端 — 用户行为统计（收藏 / 浏览 / 对比 / 地址）
 * 数据来源：C 端用户行为落库（scenic_favorite / scenic_browse_history / scenic_compare_log / scenic_user_address）
 */

export function getFavoritePage(params: any) {
  return request.get({ url: '/scenic/behavior/favorite-page', params });
}

export function getFavoriteStats() {
  return request.get({ url: '/scenic/behavior/favorite-stats' });
}

export function getBrowsePage(params: any) {
  return request.get({ url: '/scenic/behavior/browse-page', params });
}

export function getBrowseStats() {
  return request.get({ url: '/scenic/behavior/browse-stats' });
}

export function getComparePage(params: any) {
  return request.get({ url: '/scenic/behavior/compare-page', params });
}

export function getCompareStats() {
  return request.get({ url: '/scenic/behavior/compare-stats' });
}

export function getAddressPage(params: any) {
  return request.get({ url: '/scenic/behavior/address-page', params });
}

export function getAddressStats() {
  return request.get({ url: '/scenic/behavior/address-stats' });
}
